var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclusion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222 222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.89947689 4.27767567 13.62091337 9.54002247 15.875 17.62890625 C17.69379131 26.52961624 17.28420085 33.80923033 12.5625 41.6875 C8.14462742 47.79042912 1.55859118 52.42044058 -5.875 53.9375 C-14.81954129 54.93654126 -22.50496797 52.78490535 -29.6875 47.3125 C-35.26219201 42.08046045 -38.50809199 34.83122936 -38.9375 27.22265625 C-38.67821416 17.74251766 -35.74045287 11.85762088 -29.13671875 5.1796875 C-21.53982277 -1.79395981 -9.79346314 -3.66406704 0 0 Z ",
    fill: "#FF3232",
    transform: "translate(204.875,168.0625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.89947689 4.27767567 13.62091337 9.54002247 15.875 17.62890625 C17.69379131 26.52961624 17.28420085 33.80923033 12.5625 41.6875 C8.14462742 47.79042912 1.55859118 52.42044058 -5.875 53.9375 C-14.81954129 54.93654126 -22.50496797 52.78490535 -29.6875 47.3125 C-35.26219201 42.08046045 -38.50809199 34.83122936 -38.9375 27.22265625 C-38.67821416 17.74251766 -35.74045287 11.85762088 -29.13671875 5.1796875 C-21.53982277 -1.79395981 -9.79346314 -3.66406704 0 0 Z ",
    fill: "#FF3232",
    transform: "translate(38.875,168.0625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.89947689 4.27767567 13.62091337 9.54002247 15.875 17.62890625 C17.69379131 26.52961624 17.28420085 33.80923033 12.5625 41.6875 C8.14462742 47.79042912 1.55859118 52.42044058 -5.875 53.9375 C-14.81954129 54.93654126 -22.50496797 52.78490535 -29.6875 47.3125 C-35.26219201 42.08046045 -38.50809199 34.83122936 -38.9375 27.22265625 C-38.67821416 17.74251766 -35.74045287 11.85762088 -29.13671875 5.1796875 C-21.53982277 -1.79395981 -9.79346314 -3.66406704 0 0 Z ",
    fill: "#FF3232",
    transform: "translate(204.875,2.0625)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.89947689 4.27767567 13.62091337 9.54002247 15.875 17.62890625 C17.69379131 26.52961624 17.28420085 33.80923033 12.5625 41.6875 C8.14462742 47.79042912 1.55859118 52.42044058 -5.875 53.9375 C-14.81954129 54.93654126 -22.50496797 52.78490535 -29.6875 47.3125 C-35.26219201 42.08046045 -38.50809199 34.83122936 -38.9375 27.22265625 C-38.67821416 17.74251766 -35.74045287 11.85762088 -29.13671875 5.1796875 C-21.53982277 -1.79395981 -9.79346314 -3.66406704 0 0 Z ",
    fill: "#FF3232",
    transform: "translate(38.875,2.0625)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 3.96 32 7.92 32 12 C21.44 12 10.88 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#FF3131",
    transform: "translate(95,109)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(186,149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(20,149)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(186,119)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(20,119)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(186,89)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(20,89)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(186,59)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C16 4.95 16 9.9 16 15 C10.72 15 5.44 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3D3D",
    transform: "translate(20,59)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(148,187)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(118,187)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(88,187)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(58,187)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(148,21)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(118,21)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(88,21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 4.95 15 9.9 15 15 C10.05 15 5.1 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FF3737",
    transform: "translate(58,21)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusion);
export default __webpack_public_path__ + "static/media/exclusion.8baa3dfd1713474f7d0b37599766f87b.svg";
export { ForwardRef as ReactComponent };